// extracted by mini-css-extract-plugin
module.exports = {"character-counter":"character-counter--1uV31uHoYi","characterCounter":"character-counter--1uV31uHoYi","exceeded":"exceeded--1EIjgAWxp1"};